import React from 'react';
import { LoaderFunctionArgs, RouteObject } from 'react-router-dom';
import StartPage from './Features/Start';
import TechnologyPage from './Features/Technology';
import TechnologyList from './Features/Technology/List';
import UpdateTechnology from './Features/Technology/Update';
import NewTechnology from './Features/Technology/Add';
import ClientPage from './Features/Client';
import ClientList from './Features/Client/List';
import UpdateClient from './Features/Client/Update';
import NewClient from './Features/Client/Add';
import AggregatedDataLoader from './Loaders/AggregatedDataLoader';
import TechnologyLoader from './Loaders/TechnologyLoader';
import ClientLoader from './Loaders/ClientLoader';
import { Logout } from './Features/Logout';
import { Login } from './Features/Login';
import ProtectedRoute from './Features/ProtectedRoute';
import RadarAdmin from './Features/RadarAdmin';
import RingsAndSectionsLoader from './Loaders/RingsAndSectionsLoader';
import EntityAdmin from './Features/EntityAdmin';
import EditEntityLoader from './Loaders/EditEntityLoader';
import {
  getRings,
  getSections,
  getTechnologiesInRing,
  getTechnologiesInSection,
  updateRing,
  updateSection,
} from './Util/server';

export type RouteExposure = 'No' | 'LoggedIn' | 'All' | 'Admins';

export type RouteType = {
  label?: string;
  path: string;
  element: JSX.Element;
  displayInNavigation: RouteExposure;
  loader?: (params: any) => any;
};

const routes: (RouteObject & RouteType)[] = [
  {
    path: '/login',
    element: <Login />,
    displayInNavigation: 'No',
  },
  {
    label: 'Home',
    path: '/',
    element: (
      <ProtectedRoute redirectPath="/login">
        <StartPage />
      </ProtectedRoute>
    ),
    displayInNavigation: 'LoggedIn',
    loader: AggregatedDataLoader,
  },
  {
    label: 'Technologies',
    path: '/technologies',
    element: (
      <ProtectedRoute redirectPath="/login">
        <TechnologyList />
      </ProtectedRoute>
    ),
    displayInNavigation: 'LoggedIn',
    loader: AggregatedDataLoader,
  },
  {
    path: 'technology/:name',
    element: (
      <ProtectedRoute redirectPath="/login">
        <TechnologyPage />
      </ProtectedRoute>
    ),
    loader: TechnologyLoader,
    displayInNavigation: 'No',
  },
  {
    label: 'Add new technology',
    path: '/technologies/add',
    element: (
      <ProtectedRoute redirectPath="/technologies">
        <NewTechnology />
      </ProtectedRoute>
    ),
    loader: AggregatedDataLoader,
    displayInNavigation: 'Admins',
  },
  {
    path: '/technology/:name/edit',
    element: (
      <ProtectedRoute redirectPath="/technology/" paramName="name">
        <UpdateTechnology />
      </ProtectedRoute>
    ),
    loader: AggregatedDataLoader,
    displayInNavigation: 'No',
  },
  {
    label: 'Clients',
    path: '/clients',
    element: (
      <ProtectedRoute redirectPath="/login">
        <ClientList />
      </ProtectedRoute>
    ),
    displayInNavigation: 'LoggedIn',
    loader: AggregatedDataLoader,
  },
  {
    path: '/client/:name',
    element: (
      <ProtectedRoute redirectPath="/login">
        <ClientPage />
      </ProtectedRoute>
    ),
    loader: ClientLoader,
    displayInNavigation: 'No',
  },
  {
    label: 'Add new client',
    path: '/clients/add',
    element: (
      <ProtectedRoute redirectPath="/clients">
        <NewClient />
      </ProtectedRoute>
    ),
    loader: AggregatedDataLoader,
    displayInNavigation: 'Admins',
  },
  {
    path: '/client/:name/edit',
    element: (
      <ProtectedRoute redirectPath="/client/" paramName="name">
        <UpdateClient />
      </ProtectedRoute>
    ),
    loader: AggregatedDataLoader,
    displayInNavigation: 'No',
  },
  {
    label: 'Settings',
    path: '/settings',
    element: (
      <ProtectedRoute redirectPath="/">
        <RadarAdmin />
      </ProtectedRoute>
    ),
    loader: RingsAndSectionsLoader,
    displayInNavigation: 'Admins',
  },
  {
    path: '/settings/section/:name',
    element: (
      <ProtectedRoute redirectPath="/">
        <EntityAdmin type={'Section'} updateEntity={updateSection} />
      </ProtectedRoute>
    ),
    loader: (args: LoaderFunctionArgs) =>
      EditEntityLoader({
        params: args.params,
        request: args.request,
        getEntities: getSections,
        getTechnologies: getTechnologiesInSection,
      }),
    displayInNavigation: 'No',
  },
  {
    path: '/settings/ring/:name',
    element: (
      <ProtectedRoute redirectPath="/">
        <EntityAdmin type={'Ring'} updateEntity={updateRing} />
      </ProtectedRoute>
    ),
    loader: (args: LoaderFunctionArgs) =>
      EditEntityLoader({
        params: args.params,
        request: args.request,
        getEntities: getRings,
        getTechnologies: getTechnologiesInRing,
      }),
    displayInNavigation: 'No',
  },
  {
    path: '/logout',
    element: <Logout />,
    displayInNavigation: 'No',
  },
  {
    path: '*',
    element: (
      <ProtectedRoute redirectPath="/login">
        <StartPage />
      </ProtectedRoute>
    ),
    displayInNavigation: 'No',
  },
];

export default routes;
